import { Auth, connectAuthEmulator, getAuth } from 'firebase/auth';
import { app } from './app';
import { getEmulatorHost, isEmulatorEnabled } from './emulator-config';

export const auth: Auth = getAuth(app);

if (isEmulatorEnabled()) {
  connectAuthEmulator(auth, `http://${getEmulatorHost()}:9099`, {
    disableWarnings: true,
  });
}